module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_j_normal.03a4291c.png";